import * as actionTypes from './actionTypes';

export const toggleLeftOverlay = (name, force = false, updateParam = 2) => ({
  type: actionTypes.TOGGLE_LEFT_OVERLAY,
  name,
  force,
  updateParam,
});

export const setLoading = (loading, loadingType = 'default', callback = null) => ({
  type: actionTypes.SET_LOADING,
  loading,
  loadingType,
  callback,
});

export const setMobile = state => ({
  type: actionTypes.SET_MOBILE,
  state,
});

export const setHeaderUpdating = state => ({
  type: actionTypes.SET_HEADER_UPDATING,
  state,
});

export const toggleMenuCollapse = state => ({
  type: actionTypes.TOGGLE_MENU_COLLAPSE,
  state,
});

export const setPopupState = state => ({
  type: actionTypes.SET_POPUP_STATE,
  state,
});

export const setActiveTab = (tab, updateParam = 1) => ({
  type: actionTypes.SET_ACTIVE_TAB,
  tab,
  updateParam,
});

export const setMapStyle = (style, updateParam = 1) => ({
  type: actionTypes.SET_MAP_STYLE,
  style,
  updateParam,
});

export const setBreadcrumbs = state => ({
  type: actionTypes.SET_BREADCRUMBS,
  state,
});

export const addBreadcrumb = state => ({
  type: actionTypes.ADD_BREADCRUMB,
  state,
});

export const setDownloadProgress = state => ({
  type: actionTypes.SET_DOWNLOAD_PROGRESS,
  state,
});
